import { Component, OnInit } from '@angular/core';
import {DocumentRepositoryCellViewerComponent} from '../cell-components/document-repository-cell-viewer/document-repository-cell-viewer.component';
import {ParticleService} from '@core/services/particle.service';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {select} from '@ngrx/store';
import {QueryProvider} from '@shared/queries/query-provider';
import {Router} from '@angular/router';

@Component({
    standalone: false,
    selector: 'particle-document-repository',
  templateUrl: './document-repository.component.html',
  styleUrls: ['./document-repository.component.scss']
})
export class DocumentRepositoryComponent implements OnInit {
  sourceKey: string;
  breadcrumbs: BreadcrumbModel[];
  constructor(private router: Router) {
    this.sourceKey = 'DocumentRepository';
    this.breadcrumbs = [
      <BreadcrumbModel>{
          id : 'Repository',
          title: 'Repository',
          type: 'Repository',
          relativeUrl: 'repository'
        }
      ];
  }

  ngOnInit() {

  }

  onGridCellValueChange($event) {
    let driveType;
    console.log('Show me the event:::', $event);
    if ($event) {
      if ($event.item && $event.item.cells && $event.item.cells['Type'] ) {
        driveType = $event.item.cells['Type'].value;
      }
      if ($event.cells && $event.cells['Type']) {
        driveType = $event.cells['Type'].value;
      }
    }
    if (driveType) {
      switch (driveType) {
        case 'SharedDrives':
          this.router.navigateByUrl('team-drives');
          break;
        case 'SharedDrive':
          this.router.navigateByUrl(`drive/${$event.id}`);
          break;
        case 'PersonalDrive':
          this.router.navigateByUrl(`drive/${$event.id}`);
          break;
        case 'SharedWithMe':
          this.router.navigateByUrl(`shared-with-me`);
          break;
      }
    } else {
      if (!$event.cells['DriveId'] || !$event.cells['DriveId'].value) {
        console.error('Drive ID not found');
      } else {
        this.router.navigateByUrl(`drive/${$event.cells['DriveId'].value}/${$event.id}`);
      }
    }
  }
}
